var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import api from '@utils/axios';
import { mapCreateQuestionSetToApiRequest, mapUpdateQuestionSetToApiRequest } from './mapper';
// Get all component question sets
export function getComponentQuestionSets() {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.get('/api/internal/component_question_sets');
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error fetching component question sets:', error);
            return {
                error: {
                    message: 'Failed to fetch component question sets'
                }
            };
        }
    });
}
// Create a new component question set
export function createComponentQuestionSet(data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const requestData = mapCreateQuestionSetToApiRequest(data);
            const response = yield api.post('/api/internal/component_question_sets', requestData);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error creating component question set:', error);
            return {
                error: {
                    message: 'Failed to create component question set'
                }
            };
        }
    });
}
// Update an existing component question set
export function updateComponentQuestionSet(id, data) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const requestData = mapUpdateQuestionSetToApiRequest(data);
            const response = yield api.patch(`/api/internal/component_question_sets/${id}`, requestData);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error updating component question set:', error);
            return {
                error: {
                    message: 'Failed to update component question set'
                }
            };
        }
    });
}
// Toggle active status of a component question set
export function toggleComponentQuestionSetStatus(id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield api.patch(`/api/internal/component_question_sets/${id}/toggle_active`);
            if (!response.data) {
                throw new Error('No data received from server');
            }
            return {
                data: response.data
            };
        }
        catch (error) {
            console.error('Error toggling component question set status:', error);
            return {
                error: {
                    message: 'Failed to toggle component question set status'
                }
            };
        }
    });
}
